import { render, staticRenderFns } from "./EmployeeAddEdit.vue?vue&type=template&id=10cc9b1d"
import script from "./EmployeeAddEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports